function PredictionResult({ prediction }) {
  // Handle the actual API response structure
  const pred = prediction.fallback?.label || prediction.basic_prediction?.label || prediction.prediction || prediction.final_prediction || 'Unknown';
  const confidence = prediction.fallback?.confidence || prediction.basic_prediction?.confidence || prediction.confidence;

  // Convert topk array format [[label, score], ...] to [{label, score}, ...]
  const rawTopk = prediction.topk || [];
  const topk = Array.isArray(rawTopk) && rawTopk.length > 0
    ? (Array.isArray(rawTopk[0])
        ? rawTopk.map(([label, score]) => ({ label, score }))
        : rawTopk)
    : [];

  return (
    <div className="prediction-result">
      <div className={`main-prediction label-${pred}`}>
        Prediction: <strong>{pred}</strong>
        {confidence && !isNaN(confidence) && ` (${(confidence * 100).toFixed(1)}%)`}
      </div>

      {prediction.fallback && prediction.fallback.label !== prediction.basic_prediction?.label && (
        <div className="fallback-correction">
          Fallback: <span className="original">{prediction.basic_prediction?.label}</span> → {pred}
        </div>
      )}

      {prediction.fallback?.rule_path && (
        <div className={`rule-info rule-${prediction.fallback.rule_path.replace(/_/g, '-').toLowerCase()}`}>
          Rule: {prediction.fallback.rule_path}
        </div>
      )}

      {prediction.fallback?.cues_matched && Object.keys(prediction.fallback.cues_matched).some(key => prediction.fallback.cues_matched[key].length > 0) && (
        <div className="cues-detected">
          Cues:{' '}
          {(() => {
            const cueElements = Object.entries(prediction.fallback.cues_matched)
              .filter(([, cues]) => cues.length > 0)
              .map(([type, cues]) => (
                <span key={type} className={`cue-${type}`}>
                  {type}({cues.join(', ')})
                </span>
              ));

            return cueElements.flatMap((element, index) =>
              index === cueElements.length - 1 ? [element] : [element, ', ']
            );
          })()}
        </div>
      )}

      {prediction.fallback?.policy && (
        <div className={`policy-routing policy-${prediction.fallback.policy.replace(/_/g, '-')}`}>
          Policy: {prediction.fallback.policy}
        </div>
      )}

      {topk.length > 0 && (
        <div className="meta">
          <div className="topk">
            {topk.map((item, i) => {
              const score = item.confidence ?? item.score ?? 0;
              return (
                <span key={i} className={`pill label-${item.label}`}>
                  {item.label} {score && !isNaN(score) ? (score * 100).toFixed(1) : '0'}%
                </span>
              );
            })}
          </div>
          <div className="bars">
            {topk.map((item, i) => {
              const score = item.confidence ?? item.score ?? 0;
              return (
                <div key={i} className="bar">
                  <span style={{ width: `${score && !isNaN(score) ? score * 100 : 0}%` }}></span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default PredictionResult;